/* src/app/user-stats/user-stats.component.css */
#container {
  height: 60rem;
  width: 100%;
}
#legendItems {
  font-size: medium;
  text-align: left;
}
.legendRed {
  color: red;
}
.legendGreen {
  color: green;
}
@media (max-width: 767px), screen and (max-width: 812px) and (orientation: landscape) {
  #container {
    height: 50rem;
    width: 33rem;
  }
}
#copy {
  width: 18rem;
  margin: auto;
  width: 50%;
  text-align: center;
}
th {
  padding-right: 10px;
}
.perfCon {
  height: max-content;
  width: max-content;
}
@media (max-width: 767px), screen and (max-width: 812px) and (orientation: landscape) {
  #container {
    height: 50rem;
  }
}
@media (max-width: 767px), screen and (max-width: 812px) and (orientation: landscape) {
  .perfCon {
    height: 50rem;
    width: 32rem;
    margin: auto;
  }
}
.perfMarg {
  margin-left: 17%;
  margin-right: 17%;
}
@media (max-width: 767px), screen and (max-width: 812px) and (orientation: landscape) {
  .perfMarg {
    margin: auto;
  }
}
.copiersCon {
  width: 90rem;
}
@media (max-width: 767px), screen and (max-width: 812px) and (orientation: landscape) {
  .copiersCon {
    width: 32rem;
    height: 50rem;
  }
}
.riskCon {
  width: 90rem;
}
@media (max-width: 767px), screen and (max-width: 812px) and (orientation: landscape) {
  .riskCon {
    width: 32rem;
    height: 50rem;
  }
}
.portfolioTab {
  margin-left: 3rem;
}
@media (max-width: 767px), screen and (max-width: 812px) and (orientation: landscape) {
  .portfolioTab {
    width: 10rem;
    font-size: small;
  }
}
.templateCharts {
}
@media (max-width: 767px), screen and (max-width: 812px) and (orientation: landscape) {
  .templateCharts {
    margin-top: 10rem;
  }
}
.portHeading {
  padding-right: 14rem;
}
@media (max-width: 767px), screen and (max-width: 812px) and (orientation: landscape) {
  .portHeading {
    padding-right: 5px;
  }
}
.portLeft {
  padding-left: 14rem;
}
@media (max-width: 767px), screen and (max-width: 812px) and (orientation: landscape) {
  .portLeft {
    padding-left: 0rem;
  }
}
.mobileTab {
  margin-top: 2rem;
  padding-bottom: 1rem;
}
@media (max-width: 767px), screen and (max-width: 812px) and (orientation: landscape) {
  .mobileTab {
    margin-top: 18%;
    overflow: hidden;
  }
}
.feedTab {
  margin-left: 18%;
  margin-right: 18%;
}
@media (max-width: 767px), screen and (max-width: 812px) and (orientation: landscape) {
  .feedTab {
    margin-left: 0rem;
    margin-right: 0rem;
  }
}
.navItems {
  padding-right: 4rem;
}
@media (max-width: 767px), screen and (max-width: 812px) and (orientation: landscape) {
  .navItems {
    padding-right: 1rem;
  }
}
.navText {
  font-size: large;
}
@media (max-width: 767px), screen and (max-width: 812px) and (orientation: landscape) {
  .mobileAvgCop {
    margin-bottom: 1.5rem;
  }
}
.avgMarg {
}
@media (max-width: 767px), screen and (max-width: 812px) and (orientation: landscape) {
  .avgMarg {
    margin: auto;
  }
}
.copyMarg {
  margin-left: 17%;
  margin-right: 17%;
}
@media (max-width: 767px), screen and (max-width: 812px) and (orientation: landscape) {
  .copyMarg {
    margin: auto;
  }
}
.err {
  text-align: center;
  padding-top: 12%;
  padding-bottom: 12%;
}
@media (max-width: 767px), screen and (max-width: 812px) and (orientation: landscape) {
  .err {
    text-align: center;
    padding-top: 10rem;
    padding-bottom: 10rem;
  }
}
.btn {
  display: inline-block;
  vertical-align: middle;
  text-align: center;
  cursor: pointer;
  text-decoration: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  background-color: red;
  border-radius: 0.4rem;
  font-weight: 700;
  color: #fff;
  border: 0.2rem solid red;
  min-width: 5rem;
  padding: 0 1rem;
  -webkit-transition:
    background-color 0.4s,
    border-color 0.4s,
    color 0.4s;
  -o-transition:
    background-color 0.4s,
    border-color 0.4s,
    color 0.4s;
  transition:
    background-color 0.4s,
    border-color 0.4s,
    color 0.4s;
  min-height: 2rem;
  line-height: 5.6rem;
  font-size: 1.2rem;
}
.btn:hover {
  background-color: #fff;
  color: red;
}
.btn--secondary {
  min-width: 10.7rem;
  background-color: transparent;
  min-height: 4.6rem;
  line-height: 4.2rem;
  font-size: 1.6rem;
  font-family:
    "Poppins",
    Helvetica,
    Arial,
    sans-serif;
  color: red;
}
.btn--delete {
  min-width: 10.7rem;
  background-color: red;
  min-height: 4.6rem;
  line-height: 4.2rem;
  font-size: 1.6rem;
  font-family:
    "Poppins",
    Helvetica,
    Arial,
    sans-serif;
  color: white;
}
.btn--delete:hover {
  min-width: 10.7rem;
  background-color: red;
  min-height: 4.6rem;
  line-height: 4.2rem;
  font-size: 1.6rem;
  font-family:
    "Poppins",
    Helvetica,
    Arial,
    sans-serif;
  color: white;
}
#container {
  height: 100%;
  width: 100%;
}
#legendItems {
  font-size: medium;
  text-align: left;
}
.legendRed {
  color: red;
}
.legendGreen {
  color: green;
}
@media (max-width: 767px), screen and (max-width: 812px) and (orientation: landscape) {
  #container {
    height: 50rem;
  }
}
#legend {
  padding-left: 1rem;
  color: white;
}
@media (max-width: 767px), screen and (max-width: 812px) and (orientation: landscape) {
  #legend {
    margin-left: 0rem;
    padding-left: 1rem;
    color: white;
  }
}
.legendGrad {
  background-image:
    linear-gradient(
      to right,
      #BACEE7,
      #ACC0E1,
      white);
}
.legendShadow {
  box-shadow: 1px 2px 14px rgba(0, 0, 0, .5);
}
.legendRed {
  color: red;
}
.legendGreen {
  color: green;
}
#legendItems {
  width: 100%;
}
#container {
  height: 75rem;
  width: 100%;
}
@media (max-width: 767px), screen and (max-width: 812px) and (orientation: landscape) {
  #container {
    height: 50rem;
  }
}
.brochurePos {
  margin-left: 0rem;
}
@media (max-width: 767px), screen and (max-width: 812px) and (orientation: landscape) {
  .brochurePos {
    margin-left: 2.5rem;
  }
}
#about {
}
.nsdqChart {
  width: 840px;
  height: 680px;
}
@media (max-width: 767px), screen and (max-width: 812px) and (orientation: landscape) {
  .nsdqChart {
    width: 100%;
    height: 280px;
  }
  .highcharts-legend {
    pointer-events: none;
  }
}
.hide {
  display: none;
}
::ng-deep .eapps-facebook-feed-popup-item-info {
  overflow: scroll !important;
}
@media only screen and (max-width: 640px) {
  ::ng-deep .eapps-facebook-feed-popup-close {
    background-color: black;
    border-radius: 100%;
  }
}
@media only screen and (max-width: 640px) {
  ::ng-deep .eapps-facebook-feed-popup-close {
    opacity: 34% !important;
  }
}
#theGraph {
  scroll-margin-bottom: 30vh;
}
#risk {
  scroll-margin-bottom: 30vh;
}
/*# sourceMappingURL=user-stats.component.css.map */
